import UISearchInput from 'UIComponents/input/UISearchInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PatagoniaSearchBarContainer = ({
  sidebarSearchQuery,
  handleSearchInput,
  isDisabled,
  className
}) => {
  const handleOnChange = useCallback(e => {
    handleSearchInput(e.target.value);
  }, [handleSearchInput]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": "Search",
    className: `search-input ${className}`,
    children: /*#__PURE__*/_jsx(UISearchInput, {
      use: "on-dark",
      value: isDisabled ? '' : sidebarSearchQuery,
      placeholder: "",
      onChange: handleOnChange,
      disabled: isDisabled
    })
  });
};
export default PatagoniaSearchBarContainer;